import { customGetWishListLinesV2 } from "@NA/Services/ADISaveForLater";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { WishListLineModel } from "@insite/client-framework/Types/ApiModels";

interface LoadWishListApiParameter {
    wishListId: string;
    parameter?: any;
    name: string;
    onSuccess?: (result: any) => void;
}

type HandlerType = CustomApiHandler<LoadWishListApiParameter, WishListLineModel>;

export const LoadWishListV2: HandlerType = async (props: any) => {
    props.apiResult = await customGetWishListLinesV2(props.parameter);
    props.parameter.onSuccess(props.apiResult);
};

export const chain = [LoadWishListV2];

const loadWishListLineV2 = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        wishListId: "",
        name: "",
    },
    "loadWishListLineV2",
);
export default loadWishListLineV2;
